import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Form,
  FormFeedback,
  Label,
  Input,
  UncontrolledTooltip,
  Media,
  Spinner,
} from "reactstrap";
import AuthSlider from "../authCarousel";
import React, { useEffect, useRef, useState } from "react";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";
import withRouter from "Components/Common/withRouter";
import { CreateBusiness } from "slices/thunks";
import { useDispatch } from "react-redux";
import { validateStoreName } from "helpers/backend_helper";
import infoIcon from "../../../assets/images/i.png";
import MediaUploader from "Components/Common/MediaUploader";
import { toast, ToastContainer } from "react-toastify";
import { handleLogout } from "helpers/api_helper";

export type DayOption = {
  value: string;
  label: string;
};

let storeTimeout: any;
const CoverPasswReset = (props: any) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [storeExists, setstoreExists] = useState<boolean>(false);
  const dispatch: any = useDispatch();
  document.title = "Set Seller Store";
  const navigate = useNavigate();
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
     const storeNameRef = useRef<HTMLInputElement>(null);
  const [storeNameInput, setStoreNameInput] = useState("");
  const [debouncedStoreName, setDebouncedStoreName] = useState("");

const validation = useFormik<{
    storeName: string;
    accountType: string;
    timings: {
      day: string;
      startTime: string;
      endTime: string;
      isOpen: boolean;
    }[];
    shopLogo: null;
  }>({
    enableReinitialize: true,
    initialValues: {
      storeName: "",
      accountType: "personal",
      timings: [
        { day: "monday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "tuesday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "wednesday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "thursday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "friday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "saturday", startTime: "09:00", endTime: "18:00", isOpen: false },
        { day: "sunday", startTime: "09:00", endTime: "18:00", isOpen: false },
      ],
      shopLogo: null,
    },
    validationSchema: Yup.object({
      storeName: Yup.string().required("Please Enter Your Store Name"),
      accountType: Yup.string().required("Please select an account type"),
    }),
    onSubmit: async (values) => {
      if (!values.storeName) {
        validation.setFieldTouched("storeName", true, true);
        if (storeNameRef.current) {
          storeNameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          storeNameRef.current.focus();
        }
        return;
      }

      const transformedTimings = values.timings.map((timing) => ({
        day: timing.day,
        slotsTiming: timing.isOpen
          ? [
              {
                startTime: timing.startTime,
                endTime: timing.endTime,
              },
            ]
          : [],
        isOpen: timing.isOpen,
      }));

      const transformedValues = {
        ...values,
        timings: transformedTimings,
      };

      try {
        setLoader(true);
        await dispatch(CreateBusiness(transformedValues, props.router.navigate));
      } catch (error: any) {
        console.error("Error during business creation:", error);
      } finally {
        setLoader(false);
      }
    },
  });

  // Handle input change
  const handleStoreNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    validation.setFieldValue("storeName", value, true);
    setStoreNameInput(value);
  };

  // Debounce input (3 seconds)
  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      setDebouncedStoreName(storeNameInput);
    }, 3000);
  }, [storeNameInput]);

  // Trigger API validation on debounced input
  useEffect(() => {
    if (debouncedStoreName.trim() !== "") {
      checkStoreNameAvailability(debouncedStoreName);
    }
  }, [debouncedStoreName]);

  const checkStoreNameAvailability = async (value: string) => {
    try {
      const response: any = await validateStoreName(value);
      if (!response.isSuccess) {
        validation.setFieldError("storeName", "Store Name already exists");
      } else {
        validation.setFieldError("storeName", "");
      }
    } catch (error) {
      console.error("Store name validation error:", error);
      validation.setFieldError("storeName", "Server error. Try again later.");
    }
  };
  // const handleStoreNameChange = async (e: any) => {
  //   const validateStoreNameViaServer = async (value: string) => {
  //     try {
  //       const response: any = await validateStoreName(value);
  //       setstoreExists(response.isSuccess);
  //     } catch (error) {
  //       validation.setFieldError(
  //         "storeName",
  //         "Server error. Please try again later."
  //       );
  //     }
  //   };

  //   const { value } = e.target;
  //   validation.setFieldValue("storeName", value);
  //   if (value.trim() === "") {
  //     validation.setFieldError("storeName", "Please Enter Your Store Name");
  //     return;
  //   }

  //   clearTimeout(storeTimeout);
  //   storeTimeout = setTimeout(() => validateStoreNameViaServer(value), 1000);
  // };

  const handleFieldChange = (key: string, e: any) => {
    validation.setFieldValue(key, e.target.value);
  };

  useEffect(() => {
    if (validation.errors.storeName && storeNameRef.current) {
      storeNameRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      storeNameRef.current.focus();
    }
  }, [validation.errors.storeName]);

  const [selectedShopLogo, setShopLogo] = useState<any>();

  const onMediaUpdate = (key: string, value: Media | any) => {
    console.log(key, value);
    if (key === "shopLogo") {
      setShopLogo(value);
      const shopLogoData = {
        url: value?.url,
        metaData: {
          height: value?.metaData?.height,
          width: value?.metaData?.width,
          fileType: value?.metaData?.fileType,
          fileFormat: value?.metaData?.fileFormat,
          name: value?.metaData?.name,
          duration: value?.metaData?.duration,
        },
      };
      validation.setFieldValue("shopLogo", shopLogoData);
    }
  };

  interface Schedule {
    isOpen: boolean;
    startTime: string;
    endTime: string;
  }

  type ScheduleState = {
    [key: string]: Schedule;
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="auth-page-wrapper auth-bg-cover py-md-5 d-md-flex justify-content-center align-items-center min-vh-100 auth-form pull-up-from-mobile-footer">
        <div className="bg-overlay"></div>
        <div className="auth-page-content overflow-hidden pt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <Card className="Specific-Class-for-border cardHightDv overflow-hidden">
                  <Row className="justify-content-center g-0 h-100">
                    <AuthSlider />

                    <Col
                      lg={6}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div className="d-flex justify-content-center align-items-center h-100 w-100">
                        {/* <SimpleBar style={{height:"calc(100vh - 27vh)", overflow:"auto"}} className="px-3 w-100"> */}
                        <div className="height-of-login p-4 w-100 height-of-pwdreset">
                          <div className="fliedBox fxdBottom">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                              }}
                            >
                              <div className="fieldsGroup">
                                <h1>Setup Your Account</h1>

                                <div className=" formContainer mobileResPass mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="email-input"
                                  >
                                    <span className="text-danger">*</span>
                                    Digital Store Name
                                  </label>
                                  <Input
                                    name="storeName"
                                    data-testing-Id="storeNameInput_Accountype"
                                    className="form-control leftPad"
                                    placeholder="Enter Digital Store Name"
                                    type="text"
                                    innerRef={storeNameRef}
                                    onChange={handleStoreNameChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.storeName || ""}
                                    invalid={
                                      validation.touched.storeName &&
                                      validation.errors.storeName
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.errors.storeName ? (
                                    <FormFeedback
                                      type="invalid"
                                      className="positoleft"
                                    >
                                      {validation.errors.storeName}
                                    </FormFeedback>
                                  ) : null}

                                  <i className="ri-store-line text-secondary lefticonInfoDv"></i>
                                </div>

                                <p className="mb-2 fs-16">Account Type</p>
                                <div className="d-flex my-1 gap-3 mobileResPass  selectDv">
                                  <div
                                    className={`selectedDv ${
                                      validation.values.accountType ===
                                      "personal"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <div className="d-flex gap-2">
                                      <Input
                                        className="form-check-input"
                                        type="radio"
                                        name="accountType"
                                        id="personalAccount"
                                        value="personal"
                                        data-testing-Id="personalChexkBox_Accountype"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        checked={
                                          validation.values.accountType ===
                                          "personal"
                                        }
                                      />
                                      <Label
                                        className="form-check-label d-flex align-items-center"
                                        htmlFor="personalAccount"
                                      >
                                        Personal
                                      </Label>
                                    </div>
                                    <div>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          marginBottom: "5px",
                                          cursor: "pointer",
                                        }}
                                        id="personal"
                                      >
                                        <img
                                          src={infoIcon}
                                          alt=""
                                          height={14}
                                          width={14}
                                        />
                                      </span>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="personal"
                                      >
                                        This account type is ideal for
                                        individual sellers who want to sell
                                        products online. It allows you to manage
                                        your listings, process orders, and
                                        engage with customers on the platform,
                                        while offering a streamlined and
                                        simplified user experience.
                                      </UncontrolledTooltip>
                                    </div>
                                  </div>
                                  <div
                                    className={`selectedDv ${
                                      validation.values.accountType ===
                                      "business"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <div className="d-flex gap-2">
                                      <Input
                                        className="form-check-input"
                                        type="radio"
                                        name="accountType"
                                        id="businessAccount"
                                        value="business"
                                        data-testing-Id="businessChexkBox_Accountype"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        checked={
                                          validation.values.accountType ===
                                          "business"
                                        }
                                      />
                                      <Label
                                        className="form-check-label"
                                        htmlFor="businessAccount"
                                      >
                                        Business
                                      </Label>
                                    </div>
                                    <div>
                                      <span
                                        style={{
                                          marginLeft: "10px",
                                          marginBottom: "5px",
                                          cursor: "pointer",
                                        }}
                                        id="business"
                                      >
                                        <img
                                          src={infoIcon}
                                          alt=""
                                          height={14}
                                          width={14}
                                        />
                                      </span>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="business"
                                      >
                                        A business account is designed for
                                        companies or businesses selling products
                                        in bulk. It offers additional features,
                                        such as advanced reporting, product
                                        categorization, and access to marketing
                                        tools to help you grow your business on
                                        the platform. You can also manage
                                        multiple sellers under the same account,
                                        enhancing your brand's reach and
                                        visibility
                                      </UncontrolledTooltip>
                                    </div>
                                  </div>
                                </div>

                                <p className="mb-2 fs-16">
                                  Schedule set standard hours
                                </p>
                                <div className="timeSchedule">
                                  {validation.values.timings.map(
                                    (timing, index) => (
                                      <Row key={index} className="timeRow mb-3">
                                        <Col
                                          lg={5}
                                          md={5}
                                          sm={12}
                                          className=" d-grid align-items-center marginResSig "
                                        >
                                          <div>
                                            <Row>
                                              <Col lg={6} md={6} sm={4}>
                                                <p className="text-dark fs-13 dayLabel">
                                                  {timing.day
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    timing.day.slice(1)}
                                                </p>
                                              </Col>
                                              <Col lg={6} md={6} sm={4}>
                                                <div className="form-check form-switch">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={timing.isOpen}
                                                    data-testing-id={
                                                      "signUpCheckBox" + index
                                                    }
                                                    onChange={() => {
                                                      const newTimings = [
                                                        ...validation.values
                                                          .timings,
                                                      ];
                                                      newTimings[index].isOpen =
                                                        !timing.isOpen;
                                                      validation.setFieldValue(
                                                        "timings",
                                                        newTimings
                                                      );
                                                    }}
                                                  />
                                                  <label className="p-0 m-0 fs-13">
                                                    {timing.isOpen
                                                      ? "Open"
                                                      : "Close"}
                                                  </label>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Col>
                                        <Col lg={7} md={7} sm={12}>
                                          {timing.isOpen && (
                                            <Row>
                                              <Col
                                                lg={5}
                                                md={5}
                                                sm={5}
                                                className=""
                                              >
                                                <input
                                                  type="time"
                                                  className="timeInputDv"
                                                  value={timing.startTime}
                                                  data-testing-id={
                                                    "signUpStartTime" + index
                                                  }
                                                  onChange={(e) => {
                                                    const newTimings = [
                                                      ...validation.values
                                                        .timings,
                                                    ];
                                                    newTimings[
                                                      index
                                                    ].startTime =
                                                      e.target.value;
                                                    validation.setFieldValue(
                                                      "timings",
                                                      newTimings
                                                    );
                                                  }}
                                                />
                                              </Col>
                                              <Col
                                                lg={2}
                                                md={2}
                                                sm={2}
                                                className="colpadNon text-center d-flex align-items-center justify-content-center"
                                              >
                                                <p
                                                  style={{ color: "#A2B1C3" }}
                                                  className="fs-13"
                                                >
                                                  TO
                                                </p>
                                              </Col>

                                              <Col
                                                lg={5}
                                                md={5}
                                                sm={5}
                                                className=""
                                              >
                                                <input
                                                  type="time"
                                                  className="timeInputDv"
                                                  data-testing-id={
                                                    "signUpEndTime" + index
                                                  }
                                                  value={timing.endTime}
                                                  onChange={(e) => {
                                                    const newTimings = [
                                                      ...validation.values
                                                        .timings,
                                                    ];
                                                    newTimings[index].endTime =
                                                      e.target.value;
                                                    validation.setFieldValue(
                                                      "timings",
                                                      newTimings
                                                    );
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                        </Col>
                                      </Row>
                                    )
                                  )}
                                </div>

                                {/* <p className='my-2 fs-16'>Store Logo Image</p> */}
                                <div className=" d-flex justify-content-start align-items-center my-4">
                                  <MediaUploader
                                    onMediaUpdate={(value: any) =>
                                      onMediaUpdate("shopLogo", value)
                                    }
                                    initialMedia={selectedShopLogo}
                                    isMultiple={false}
                                    smallUploader={true}
                                    dataTestingId="logoUploader"
                                  />
                                  <div className="ms-3">
                                    <p
                                      className="fs-13"
                                      style={{
                                        color: "#A2B1C3",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Shop Logo Upload or Drop file here.
                                    </p>
                                    <p
                                      className="fs-12"
                                      style={{
                                        color: "#A2B1C3",
                                        fontWeight: "700",
                                      }}
                                    >
                                      Max file size: 10 MB
                                    </p>
                                  </div>
                                </div>
                        
                               {/* <div className="mobile-hide">
                                 <div className="text-center mt-md-4 d-md-block d-flex flex-row-reverse gap-2 align-items-center">
                                  <Button
                                    color="secondary"
                                    className="w-100"
                                    type="submit"
                                    data-testing-Id="nextButton_Accountype"
                                    disabled={loader}
                                   >
                                    {loader && (
                                      <Spinner size="sm" className="me-2">
                                        {" "}
                                        Loading...{" "}
                                      </Spinner>
                                    )}
                                    Next
                                  </Button>
                                  <div
                                    className=" d-flex justify-content-start align-items-center cursor-pointer mt-2 mobile-hide"
                                    onClick={handleLogout}
                                    data-testing-Id="backButoon_otpVerification"
                                  >
                                    <i className="bx bx-chevron-left fs-2"></i>
                                    <p className=" text-dark">Back</p>
                                  </div>

                                  <Button
                                    color="dark"
                                    outline
                                    className="shadow-none w-100 mt-md-2 mobile-show"
                                    onClick={handleLogout}
                                  >
                                    {" "}
                                    Back{" "}
                                  </Button>
                                </div>
                              </div> */}
                              </div>

                              <div className="btnBox">
                                <div className="text-center flex-row-reverse mt-md-4 d-md-block d-flex gap-2 align-items-center">
                                  <Button
                                    color="secondary"
                                    className="w-100"
                                    type="submit"
                                    data-testing-Id="nextButton_Accountype"
                                    disabled={loader}
                                   >
                                    {loader && (
                                      <Spinner size="sm" className="me-2">
                                        {" "}
                                        Loading...{" "}
                                      </Spinner>
                                    )}
                                    Continue  
                                  </Button>
                                  <div
                                    className=" d-flex justify-content-start align-items-center cursor-pointer mt-2 mobile-hide"
                                    onClick={handleLogout}
                                    data-testing-Id="backButoon_otpVerification"
                                   >
                                    <i className="bx bx-chevron-left fs-2"></i>
                                    <p className=" text-dark">Back</p>
                                  </div>

                                  <Button
                                    color="dark"
                                    outline
                                    className="shadow-none w-100 mt-md-2 mobile-show"
                                    onClick={handleLogout}
                                  >
                                    {" "}
                                    Back{" "}
                                  </Button>
                                </div>
                        
                              </div>
                            </Form>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(CoverPasswReset);
